import { FilterOperator } from '@nemuru-eng/js-api-client';
import { useAuth } from '@nemuru-eng/providers';

import { useUserContext } from '@/contexts/UserContext/UserContext';

import { APP_ROLES } from '../config/config';

export const useRoleListFilters = () => {
  const { userEntity } = useUserContext();
  const { user } = useAuth();

  if (!userEntity) return [];

  const role = userEntity.role;

  let field: 'agent_id' | 'channel_id' | 'merchant_id' | undefined = undefined;
  switch (role) {
    case APP_ROLES.ADMIN:
      break;
    case APP_ROLES.AGENT:
      field = 'agent_id';
      break;
    case APP_ROLES.CHANNEL:
      field = 'channel_id';
      break;
    case APP_ROLES.MERCHANT:
      field = 'merchant_id';
      break;
  }

  if (!field) return [];

  if (!user?.userId) return [];

  return [
    {
      field,
      operator: FilterOperator.EQUAL,
      value: user.userId,
    },
  ];
};
